import React from 'react';
import { Link } from 'react-router-dom';

const SERVICES = [
  {
    title: 'Consultoría y Relevamiento Tecnológico',
    description:
      'Antes de escribir una sola línea de código, auditamos tus procesos. Identificamos fugas de tiempo y diseñamos una hoja de ruta técnica exacta para tu negocio.',
    image: '/assets/mascota-poses/consultoria.webp',
    dark: false,
  },
  {
    title: 'Agentes de Inteligencia Artificial',
    description:
      'Implementamos IA para ejecutar tareas complejas: desde la extracción y análisis de datos en documentos hasta la toma de decisiones autónoma en tiempo real.',
    image: '/assets/mascota-poses/agentes-ia.webp',
    // Estas 3 imágenes se dejan con su fondo original (gris o negro sólido,
    // sin canal alfa) -- quitar el fondo dañaba la definición del recorte.
    dark: true,
  },
  {
    title: 'Automatización y Despliegue On-Site o en la Nube',
    description:
      'Implementamos la solución donde tu operación lo necesite: en tu propia infraestructura o en la nube, conectando tus plataformas actuales para que la información fluya sola.',
    image: '/assets/mascota-poses/automatizacion.webp',
    dark: false,
  },
];

// Circuito simple de fondo: baja por el borde izquierdo hasta el fondo real
// de la sección, un nodo, y sigue horizontal hasta el margen derecho. Mismo
// color y opacidad que el patrón del Hero (CircuitBackground) para que se
// vea consistente, no un violeta más fuerte.
const ServicesCircuit = () => (
  <div className="absolute inset-0 z-0 pointer-events-none" aria-hidden="true">
    <div className="absolute left-4 top-0 bottom-0 w-[1.5px] bg-[#C7D2FE] opacity-70" />
    <div className="absolute left-4 right-0 bottom-0 h-[1.5px] bg-[#C7D2FE] opacity-70" />
  </div>
);

const MainframeServicesSection = () => {
  return (
    <section className="relative z-[1] bg-white px-5 sm:px-8 md:px-10 py-20 sm:py-28" id="servicios">
      <ServicesCircuit />
      <div className="max-w-3xl mb-14 sm:mb-20 relative z-10">
        <h2 style={{ fontSize: 'clamp(26px, 4.2vw, 44px)', lineHeight: 1.15, fontWeight: 500, letterSpacing: '-0.01em' }} className="text-black">
          ¿Listo para dejar de operar como antes?
        </h2>
      </div>

      <div className="relative z-10 grid grid-cols-1 md:grid-cols-3 gap-10 sm:gap-12">
        {SERVICES.map((service) => (
          <div key={service.title} className="flex flex-col">
            <div
              className={`group aspect-[3/2] rounded-2xl mb-6 overflow-hidden border-2 border-transparent transition-all duration-300 hover:border-[#7C3AED] hover:shadow-[0_0_20px_rgba(124,58,237,0.35)] ${
                service.dark ? 'bg-black' : 'bg-[#868688]'
              }`}
            >
              <img
                src={service.image}
                alt=""
                aria-hidden="true"
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
            </div>
            <h3 className="text-black text-[19px] sm:text-[21px] font-medium mb-3" style={{ letterSpacing: '-0.005em' }}>
              {service.title}
            </h3>
            <p className="text-black/60 text-[14px] sm:text-[15px] leading-relaxed mb-6 flex-1">
              {service.description}
            </p>
            <Link
              to="/servicios"
              className="inline-flex items-center gap-2 text-black text-[14px] font-medium hover:opacity-60 transition-opacity w-fit"
            >
              Ver detalles
              <span aria-hidden="true">→</span>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MainframeServicesSection;
